export default {
  'executeProcessAction.mapping': 'Mapeo',
  'executeProcessAction.addMapping': 'Agregar mapeo',
  'executeProcessAction.noMappings':
    'Aún no hay mapeos. Agrega al menos instance-name y aprobación/rechazo.',
  'executeProcessAction.requiredMissing':
    'Agrega mapeos para instance-name y aprobación/rechazo antes de guardar.',
  'executeProcessAction.form.valueDestination': 'Destino del valor',
  'executeProcessAction.form.dest.instanceName': 'Nombre de instancia',
  'executeProcessAction.form.dest.isApprovalOrReject': '¿Aprobación o rechazo?',
  'executeProcessAction.form.dest.observations': 'Observaciones de operación',
  'executeProcessAction.form.dest.formField': 'Campo de formulario',
  'executeProcessAction.form.dest.variable': 'Variable',
};
